import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import Menu, { MenuItem } from 'components/common/Menu';

const styles = () => ({
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 272,
    borderTop: 'none',
    paddingTop: 8,
    paddingBottom: 8,
    height: 'auto',
    whiteSpace: 'normal',
    textAlign: 'left',
  },
});

const OrderInformationDiagnosesMenu = ({
  open,
  anchorEl,
  id,
  onClose,
  onCreateButtonClick,
  Diagnosis,
  onItemClick,
  classes,
}) => (
  <Menu
    id={id}
    anchorEl={anchorEl}
    open={open}
    {...onClose ? { onClose } : {}}
    onListAdornmentClick={onCreateButtonClick}
    listAdornmentText="Add From List"
  >
    {Diagnosis.map(item => (
      <MenuItem
        className={classes.menuItem}
        key={item.ID}
        {...onItemClick ? { onClick: () => { onItemClick(item); } } : {}}
      >
        <Grid container spacing={16}>
          <Grid item xs={4}>
            <Typography component="span">
              {item['DX Code']}
            </Typography>
            <Typography variant="caption" component="span">
              {item.create_at}
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <Typography component="span">
              {item['Long Description']}
            </Typography>
          </Grid>
        </Grid>
      </MenuItem>
    ))}
  </Menu>
);

OrderInformationDiagnosesMenu.propTypes = {
  open: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  anchorEl: PropTypes.object,
  onClose: PropTypes.func,
  Diagnosis: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    'DX Code': PropTypes.string,
    'Long Description': PropTypes.string,
    create_at: PropTypes.string,
  })),
  id: PropTypes.string,
  onItemClick: PropTypes.func,
  onCreateButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    menuItem: PropTypes.string.isRequired,
  }).isRequired,
};

OrderInformationDiagnosesMenu.defaultProps = {
  open: false,
  anchorEl: null,
  id: null,
  onClose: null,
  Diagnosis: [],
  onItemClick: null,
  onCreateButtonClick: null,
};

export default withStyles(styles)(OrderInformationDiagnosesMenu);



// WEBPACK FOOTER //
// ./src/components/workflow/OrderInformation/OrderInformationDiagnoses/OrderInformationDiagnosesMenu.js